'use client';

import { DialogContent, type DialogContentProps } from '@chakra-ui/react';

/**
 * Precanned DialogContent: fixed, centered, fit-content width/height up to the viewport.
 * Capped height with overflow keeps tall forms (e.g. JSON editors) scrollable on mobile.
 */
export const CenteredDialogContent = (props: DialogContentProps) => (
  <DialogContent
    maxW="md"
    position="fixed"
    inset={0}
    m="auto"
    h="fit-content"
    maxH="min(92dvh, 92vh)"
    overflowY="auto"
    zIndex="modal"
    {...props}
  />
);
